/**
 * 静的背景コンポーネント
 * ログイン画面と同じ背景を表示（微妙なアニメーションと遊び心を追加）
 */

import React, { useState, useEffect } from 'react';
import { Box, useMantineColorScheme } from '@mantine/core';

export const StaticBackground: React.FC = () => {
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === 'dark';
  const [mounted, setMounted] = useState(false);
  
  // マウント時のフェードイン効果
  useEffect(() => {
    setMounted(true);
  }, []);
  
  // マウス追従を一時的に無効化（クリック問題解決のため）
  const parallax = { x: -0.2, y: -0.2 };

  return (
    <>
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.75);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        .logo-fade-in {
          animation: fadeIn 0.8s ease-out forwards;
        }
      `}</style>
      
      {/* メインの背景グラデーション（固定色） */}
      <Box
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: -10,
          pointerEvents: 'none',
          background: isDark 
            ? 'linear-gradient(135deg, #1a1b1e 0%, #25262b 100%)'
            : 'linear-gradient(135deg, #f5f7fa 0%, rgb(215, 230, 235) 100%)',
        }}
      />
      
      {/* 型押し風ロゴ（マウス追従＋フェードイン） */}
      <Box
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: `translate(calc(-50% + ${parallax.x}px), calc(-50% + ${parallax.y}px))`,
          width: '650px',
          height: '650px',
          zIndex: -10,
          pointerEvents: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'transform 0.3s ease-out',
        }}
      >
        <Box
          style={{
            width: '100%',
            height: '100%',
            backgroundImage: 'url(/public/images/h-logo.png)',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            opacity: isDark ? 0.3 : 0.3,
            filter: isDark
              ? 'grayscale(100%) contrast(0.05) brightness(0.3) invert(1) drop-shadow(0 0 8px rgba(0,0,0,0.5)) drop-shadow(3px 3px 6px rgba(0,0,0,0.8)) drop-shadow(-2px -2px 4px rgba(255,255,255,0.1))'
              : 'grayscale(100%) contrast(0.05) brightness(0.3) drop-shadow(0 0 8px rgba(0,0,0,0.2)) drop-shadow(3px 3px 6px rgba(0,0,0,0.4)) drop-shadow(-2px -2px 4px rgba(255,255,255,0.8))',
            mixBlendMode: isDark ? 'screen' : 'multiply',
          }}
        />
      </Box>
      
      {/* 追加の装飾要素（水滴風） */}
      {mounted && (
        <>
          <Box
            style={{
              position: 'fixed',
              top: '20%',
              left: '10%',
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              background: isDark
                ? 'radial-gradient(circle, rgba(255,255,255,0.01) 0%, transparent 70%)'
                : 'radial-gradient(circle, rgba(59,130,246,0.015) 0%, transparent 70%)',
              transform: `translate(${parallax.x * 0.3}px, ${parallax.y * 0.3}px)`,
              transition: 'transform 0.4s ease-out',
              pointerEvents: 'none',
              zIndex: -10,
            }}
          />
          <Box
            style={{
              position: 'fixed',
              bottom: '30%',
              right: '15%',
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              background: isDark
                ? 'radial-gradient(circle, rgba(255,255,255,0.01) 0%, transparent 70%)'
                : 'radial-gradient(circle, rgba(59,130,246,0.015) 0%, transparent 70%)',
              transform: `translate(${parallax.x * 0.2}px, ${parallax.y * 0.2}px)`,
              transition: 'transform 0.5s ease-out',
              pointerEvents: 'none',
              zIndex: -10,
            }}
          />
          <Box
            style={{
              position: 'fixed',
              top: '70%',
              left: '25%',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: isDark
                ? 'radial-gradient(circle, rgba(255,255,255,0.008) 0%, transparent 70%)'
                : 'radial-gradient(circle, rgba(59,130,246,0.012) 0%, transparent 70%)',
              transform: `translate(${parallax.x * 0.4}px, ${parallax.y * 0.4}px)`,
              transition: 'transform 0.3s ease-out',
              pointerEvents: 'none',
              zIndex: -10,
            }}
          />
        </>
      )}
    </>
  );
};